import React, { useState } from 'react'
import swal from 'sweetalert'
import { exportToExcel } from './exportToExcel'

const ExportButton = ({
	fetchAction,
	filters = {},
	columns = [],
	fileName = 'Export',
	sheetName = 'Sheet1',
	buttonClass = 'btn btn-success',
	buttonText = 'Export',
}) => {
	const [loading, setLoading] = useState(false)

	const handleExport = async () => {
		try {
			setLoading(true)

			const response = await fetchAction({
				...filters,
				page: 1,
				limit: 100000,
			})

			const data =
				response?.payload?.responses?.data?.data ||
				response?.payload?.data?.data ||
				response?.payload?.data ||
				response?.payload ||
				[]

			//console.log('Export Data:', response)

			if (!data.length) {
				swal('No Data', 'No records available to export', 'info')
				return
			}

			exportToExcel({
				data,
				fileName,
				sheetName,
				columns,
			})
		} catch (error) {
			console.error(error)
			swal('Error', 'Export failed', 'error')
		} finally {
			setLoading(false)
		}
	}

	return (
		<button className={buttonClass} onClick={handleExport} disabled={loading}>
			{loading ? (
				<>
					<i className="fas fa-spinner fa-spin mr-2"></i>
					Exporting...
				</>
			) : (
				<>
					<i className="fas fa-file-excel mr-2"></i>
					{buttonText}
				</>
			)}
		</button>
	)
}

export default ExportButton
